import {listEndpoint, type ListEndpoint} from "./util/ListEndpoint.ts";
import type {AxiosInstance} from "axios";

export interface MetlApiQueryApi {
    id: string
    files: ListEndpoint<unknown>
}

export function metlApiQueryEndpoint(axios: AxiosInstance, baseUrl: string, id: string): MetlApiQueryApi {
    return {
        id,
        files: listEndpoint(axios, `${baseUrl}/file`, `${id}/file`, () => {})
    }
}

export interface MetlApiExtractExport {
    connectorName: string
    endpoints: unknown[]
    version: string
}